import React, { useEffect, useRef, useState } from 'react';

import { Icon } from 'assets/icons';
import { useBlogService } from 'hooks/api/agents/content/blog';
import { formatDateTime } from '../../jobs/config/job';
import styles from './generate.module.css';

const RUN_POPULATION = 5;

export const GenerateBlogButton = () => {
  const { fetchBlogRuns, triggerBlogRun } = useBlogService();

  const [blog_runs, setBlogRuns] = useState([]);
  const [show_runs, setShowRuns] = useState(false);
  const [triggering, setTriggering] = useState(false);
  const runs_ref = useRef(null);

  useEffect(() => {
    handleRunsRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!show_runs) return;
    const onOutsideClick = (e) => {
      if (runs_ref.current && !runs_ref.current.contains(e.target)) setShowRuns(false);
    };
    document.addEventListener('mousedown', onOutsideClick);
    return () => document.removeEventListener('mousedown', onOutsideClick);
  }, [show_runs]);

  const handleRunsRequest = async () => {
    const { blog_runs } = await fetchBlogRuns({
      query_string: `page=0&population=${RUN_POPULATION}&sort_by=-started_at`
    });
    setBlogRuns(blog_runs);
  };

  const handleGenerate = async () => {
    setTriggering(true);
    const success = await triggerBlogRun();
    if (success) await handleRunsRequest();
    setTriggering(false);
  };

  return (
    <div className={styles.wrapper} ref={runs_ref}>
      <button
        type="button"
        className={styles.generateBtn}
        onClick={handleGenerate}
        disabled={triggering}
      >
        <Icon name="ai" width={16} height={16} />
        <span>{triggering ? 'Starting…' : 'Generate blog'}</span>
      </button>

      <button
        type="button"
        className={styles.runsBtn}
        onClick={() => {
          setShowRuns((open) => !open);
          if (!show_runs) handleRunsRequest();
        }}
      >
        <span>Recent runs</span>
        <span className={`${styles.chevron} ${show_runs ? styles.chevronOpen : ''}`}>
          <Icon name="expand" width={14} height={14} />
        </span>
      </button>

      {show_runs && (
        <div className={styles.runsMenu}>
          {blog_runs.length === 0 ? (
            <p className={styles.runsEmpty}>No runs recorded yet.</p>
          ) : (
            blog_runs.map((run, index) => (
              <div key={run.id || index} className={styles.runItem}>
                <div className={styles.runHead}>
                  {run.status && <span className={styles.runStatus}>{run.status}</span>}
                  {run.triggered_by && (
                    <span className={styles.runTrigger}>{run.triggered_by}</span>
                  )}
                </div>
                {run.started_at && (
                  <p className={styles.runDate}>{formatDateTime(run.started_at)}</p>
                )}
                {run.error && <p className={styles.runError}>{run.error}</p>}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
